import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class FeatureFlipperService {
  private features: Array<string>;

  constructor() {
    this.features = environment.features;
  }

  enabled(handle: string) {
    return this.features.indexOf(handle) !== -1;
  }
}
